"use strict";
import r from "./index.es110.js";
import o from "./index.es99.js";
function a(e, t, i) {
  r.call(this, e ?? "canceled", r.ERR_CANCELED, t, i), this.name = "CanceledError";
}
o.inherits(a, r, {
  __CANCEL__: !0
});
export {
  a as default
};
//# sourceMappingURL=index.es105.js.map
